<script setup>
import { DrawerTitle as DrawerTitlePrimitive } from "vaul-vue";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <DrawerTitlePrimitive
    data-slot="drawer-title"
    :class="
      cn('text-lg font-semibold leading-none tracking-tight', props.class)
    "
  >
    <slot />
  </DrawerTitlePrimitive>
</template>
